module.exports = __webpack_public_path__ + "assets/img/team/antonin-novak.jpg";